<template>
    <div>
        <CommonLocalBusinessSchemaComponent />
        <CommonSearchActionSchemaComponent/>
        <div class="home_bg_img_web_new home_two_bg_banner">
            <div class="home_bg_img_web_new_gradient home_banner_center">
                <div class="container_home container">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="header_text_home">
                                <!-- <h1>YOUR NEXT JOB STARTS HERE!</h1> -->
                                <h1>{{ $t('home.hero_title') }}</h1>
                                <p>{{ $t('home.hero_subtitle') }}</p>
                                <div class="filter_section_home_banner">
                                    <div class="title_filter search_common_margin_bottom_28">
                                         <div class="search-box custom_search_admin new_custom_search_admin_remove">
                                            <div role="group" class="input-group">
                                            <!---->
                                            <div
                                                class="input-group-prepend"
                                            >
                                                <input
                                                id="searchBtn"
                                                type="text"
                                                v-model="job_title_V1"
                                                :placeholder="$t('home.search_placeholder')"
                                                class="form-control"
                                                @keyup.enter="getAllJobOnSearchDPFT($event,category_id_V1,job_title_V1)"
                                                />
                                            </div>
                                            </div>
                                         </div>
                                    </div>
                                    <div class="job_type_filter search_common_margin_bottom_28">
                                        <select v-model="category_ftdp_job_type" class="select_mrgn picker" v-on:change="onChangeJobType" aria-label="Job type">
                                            <option value="" disabled selected>{{ $t('home.select_job_type') }}</option>
                                            <option value="daily_paid">{{ $t('home.job_type_part_time') }}</option>
                                            <option value="full_time">{{ $t('home.job_type_full_time') }}</option>
                                        </select>
                                        <span class="select_arrow_home material-icons-outlined">expand_more_outlined</span>
                                    </div>
                                    <div class="category_filter  search_common_margin_bottom_28" :class="category_ftdp_job_type =='full_time' ? 'cat_filter_home_two': 'pr'">
                                        <b-form-group id="input-group-9" class="required">
                                            <div class="multiselect_div">
                                                <multiselect id="ajax" v-model="category_id_V1" :tag-placeholder="$t('home.search_category')" :placeholder="$t('home.select_category')" :options="categoriesV1" label="name" track-by="alias" :multiple="false" :searchable="true" :clear-on-select="true" :close-on-select="true" :allow-empty="true" :show-labels="false" open-direction="bottom" class="job_list_multi_select model_multi_select" ><span slot="noResult">{{ $t('home.no_category_found') }}</span>
                                                </multiselect>
                                                <span class="select_arrow_home_multiple material-icons-outlined">expand_more_outlined</span>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="button_filter">
                                        <button class="" @click="getAllJobOnSearchDPFT($event,category_id_V1,job_title_V1)"><i class="fa fa-search"></i>{{ $t('home.search_job') }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="count_section_web">
                                <div class="total_jobs_web">
                                    <img :src="webUrl+'assets/images/Icon+bg.webp'" alt="Total jobs listed on EL Connect" width="240" height="240" style="height:auto">
                                    <span class="tt_span">{{ homepage_statistics.job_count | stats_format }}<br>
                                    <span class="cn_span">{{ $t('home.total_jobs') }}</span></span>
                                </div>
                                 <div class="total_jobs_web">
                                    <img :src="webUrl+'assets/images/Icon+user.webp'" alt="Total jobseekers registered on EL Connect" width="240" height="240" style="height:auto">
                                    <span class="tt_span">{{ homepage_statistics.user_count | stats_format }}<br>
                                    <span class="cn_span">{{ $t('home.total_jobseekers') }}</span></span>
                                </div>
                                 <div class="total_jobs_web">
                                    <img :src="webUrl+'assets/images/Icon+company.webp'" alt="Total employers hiring on EL Connect" width="240" height="240" style="height:auto">
                                    <span class="tt_span">{{ homepage_statistics.company_count | stats_format }}<br>
                                    <span class="cn_span">{{ $t('home.total_companies') }}</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <div class="logo_bg">
            <div class="container_home container">
                <div class="row">
                    <div class="col-xl-12 company_logo_home_new common_desktop_home_page_new">
                        <img :src="webUrl + 'assets/images/SushiTei.webp'" alt="McDonald's logo" class="mcd_img" loading="lazy">
                        <img :src="webUrl + 'assets/images/Hilton.webp'" alt="Hilton Hotels & Resorts logo" class="hilton_img" loading="lazy">
                        <img :src="webUrl + 'assets/images/ST.webp'" alt="ST Engineering logo" class="st_img" loading="lazy">
                        <img :src="webUrl + 'assets/images/GOGOX.webp'" alt="GOGOX logo" class="gogo_img" loading="lazy">
                        <img :src="webUrl + 'assets/images/Ninjavan.webp'" alt="Ninja Van logo" class="ninja_img" loading="lazy">
                        <img :src="webUrl + 'assets/images/SPX.webp'" alt="SPX Express logo" class="spx_img" loading="lazy">
                    </div>
                    <div class="col-xl-12 company_logo_home_new common_mobile_home_page_new mobile_image_of_company">
                        <div class="">
                            <div class="">
                                <img :src="webUrl + 'assets/images/SushiTei.webp'" alt="McDonald's logo" class="mcd_img" loading="lazy">
                                <img :src="webUrl + 'assets/images/Hilton-Mobile.webp'" alt="Hilton Hotels & Resorts logo" class="hilton_img" loading="lazy">
                                <img :src="webUrl + 'assets/images/ST-Mobile.webp'" alt="ST Engineering logo" class="st_img" loading="lazy">
                            </div>
                        <div class="">
                            <img :src="webUrl + 'assets/images/GOGOX-Mobile.webp'" alt="GOGOX logo" class="gogo_img" loading="lazy">
                            <img :src="webUrl + 'assets/images/Ninja-Mobile.webp'" alt="Ninja Van logo" class="ninja_img" loading="lazy">
                            <img :src="webUrl + 'assets/images/SPX-Mobile.webp'" alt="SPX Express logo" class="spx_img" loading="lazy">
                        </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
         <div class="container_home container common_padding_top_home_new">
            <div class="row">
                <div class="home_max_width_and_flex col-xl-6 col-md-6 display_grid_home two_section_home_manpower">
                    <div class="dual_section">
                        <h2 class="head_p head_p_home_two">
                            {{ $t('home.find_a_job') }}
                        </h2>
                        <p class="para_p_home">{{ $t('home.find_a_job_desc') }}</p>
                        <div class="btn_with_img">
                            <button class="btn button" @click="$bvModal.show('bv-modal-example')">{{ $t('home.start_now') }}</button>
                           <img :src="webUrl + 'assets/images/Briefcase-1.webp'" alt="Find A Job" width="574" height="400" style="width:auto;height:auto;max-height:200px">
                        </div>
                    </div>
                </div>
                 <div class="home_max_width_and_flex col-xl-6 col-md-6 display_grid_home two_section_home_manpower second_box_in_home">
                    <div class="dual_section">
                        <h2 class="head_p head_p_home_two">
                            {{ $t('home.need_manpower') }}
                        </h2>
                        <p class="para_p_home">{{ $t('home.need_manpower_desc') }}</p>
                        <div class="btn_with_img">
                            <!-- <button class="btn button">Post Today</button> -->
                            <b-link :to="{ name: 'employer3' }" target=_blank>{{ $t('home.post_today') }}</b-link>
                           <img :src="webUrl + 'assets/images/History-1.webp'" alt="Need Manpower" width="572" height="400" style="width:auto;height:auto;max-height:200px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container_home container common_padding_top_home_new">
             <div class="row">
                  <div class="col-xl-12">
                    <h2 class="common_main_heading_home_two common_dark_color_headings">{{ $t('home.part_time_available') }}</h2>
                    <div class="headings_flex">
                        <p class="part_sub_p">{{ $t('home.part_time_available_sub') }}</p>
                        <!-- <a href="#" class="view_anchor_web_home_two">View All</a> -->
						<span class=""><b-link :to="{name: 'allDailyPaidJoblisting'}" class="view_anchor_web_home_two" v-if="dailyjob_datas_count > 5">{{ $t('common.view_all') }}</b-link></span>

                    </div>
                    <!-- Browse shortcuts for this section: crawlable links into the curated hubs,
                         and the homepage is our strongest page, so these are the most valuable
                         internal links we can place. They sat at the foot of the page, where nobody
                         saw them. Seven per row, and every row arrives sorted by live job count. -->
                    <QuickSearchLinks
                        :rows="['categories', 'areas', 'roles', 'employers']"
                        :max="7"
                        inline
                    />
                    <div class="card_listing_web">
                        <div class="card_loop" v-for="(dailyjob_data, index) in dailyjob_datas" v-if="index <= 4">
                            <div class="top_flex_time_with_rate">
                                <span class="badge_span_home_listing">{{dailyjob_data.posted_date | momentFromNow}}</span>
                                <span class="rate_span_web_home_two">{{ $profile.currencySign }}{{parseFloat(dailyjob_data.hourly_cost).toFixed(2)}} {{ $t('common.per_hour') }}</span>
                            </div>
                            <div class="logo_with_title_home_two">
                                <div class="img_div_home_two_list">
                                    <img :src="dailyjob_data.thumbnail != null ? dailyjob_data.thumbnail:webUrl+'/assets/images/ELC-Group- Holdings-Limited.webp'" :alt="`Part-time ${dailyjob_data.title} job at ${dailyjob_data.company_name} in Singapore`" loading="lazy">
                                </div>
                                <div class="title_div_home_two_list">
                                    <h3 class="title_home_two_list">{{dailyjob_data.title | capitalize}} </h3>
                                    <p class="compnay_name_home_two_list">{{dailyjob_data.company_name | capitalize}}</p>
                                </div>
                            </div>
                             <div class="footer_list_home_two">
                                <div class="ul_list_home_two">
                                    <ul>
                                        <li><i class="material-icons-outlined">business_center_outlined</i><span>{{dailyjob_data.category_name}}</span></li>
                                        <li><i class="material-icons-outlined">calendar_month_outlined</i><span>{{dailyjob_data.start_date | momentDate}}</span></li>
                                        <li><i class="material-icons-outlined">schedule_outlined</i><span>{{dailyjob_data.start_time | momentTime}} - {{dailyjob_data.end_time | momentTime}}</span></li>
                                        <li><i class="material-icons-outlined">location_on_outlined</i><span>{{dailyjob_data.address | capitalize}}</span></li>
                                    </ul>
                                </div>
                                <div class="details_button_list">
                                    <!-- <a href="#" class="details_button_home_two">Job Details</a> -->
                                    <b-link class="details_button_home_two" :to="{name: 'allDailyPaidJobDetailNew', params: {company_name:dailyjob_data.alias,id: encrypt(dailyjob_data.id),job_alias:dailyjob_data.job_alias}}" target="_blank">{{ $t('home.job_details') }}</b-link>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
             </div>
        </div>
        <div class="common_padding_top_home_new">
            <div class="sky_bg">
                <div class="container_home container">
                    <div class="row">
                        <div class="col-xl-12">
                            <h2 class="common_light_color_headings common_main_heading_home_two text-center">{{ $t('home.full_time_categories') }}</h2>
                            <p class="part_sub_p text-center">{{ $t('home.full_time_categories_sub') }}</p>
                            <div class="" v-if="job_categories.length > 0">
                                <b-link @click="getAllJobOnSearch($event,'all-role-jobs',job_cat.alias,'all-title-jobs','all-location-jobs')" class="card_loop_cat" v-for="(job_cat,index) in job_categories" v-if ="index <= 7">
                                    <img :src="job_cat.service_icon != null ? job_cat.service_icon:webUrl+'/assets/images/agriculture.webp'" :alt="`${job_cat.name} full-time job category`" loading="lazy">
                                    <h3 class="heading_cat" v-if="job_cat.name.length<36">{{job_cat.name}}</h3>
                                    <h3 class="heading_cat" v-else>{{job_cat.name.substring(0,35)+"..."}}</h3>
                                    <span class="cat_count_home_two">{{job_cat.job_count}} {{ $t('common.jobs') }}</span>
                                </b-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container_home container common_padding_top_home_new common_padding_bottom_home_new">
             <div class="row">
                <div class="col-xl-12">
                    <div class="headings_flex headings_flex_two">
                        <h2 class="common_main_heading_home_two common_dark_color_headings">{{ $t('home.news_and_blog') }}</h2>
                        <b-link :to="{ name: 'blog' }" class="view_anchor_web_home_two">{{ $t('common.view_all') }}</b-link>
                    </div>
                </div>
                <div
                    v-if="featured_post.length"
                    v-for="(featured, h) in featured_post"
                    :key="h"
                    class="common_desktop_home_page_new col-xl-4 col-md-4"
                >
                    <div class="image_with_badge_section_home_two">
                        <!-- <img class="blog_image_two" :src="(featured.cover_image != null ? featured.image: webUrl+'assets/images/blog cover.webp')" :alt="`${featured.title} blog featured image`"> -->
                        <img class="blog_image_two" :src="(featured.cover_image != null ? featured.cover_image: webUrl+'assets/images/blog cover.webp')" :alt="`${featured.title} blog featured image`" loading="lazy">
                        <div class="image_overlay_home_two"></div>
                        <span class="blog_badge_home_two">{{featured.tag}}</span>
                    </div>
                    <div class="blog_box_home_two">
                        <span class="date_span_home_two">{{ featured.date | momentDate }}</span>
                        <h3 class="blog_heading_p_home_two">{{ featured.title }}</h3>
                    </div>
                    <b-link @click="blogDetail($event,featured.id,featured.title,featured.seo_permalink)" class="anchor_blog_home_two">
                        {{ $t('common.read_more') }} <span class="arrow_blog_read_more material-icons-outlined">arrow_forward_outlined</span>
                    </b-link>
                </div>
             </div>
             <VueSlickCarousel :arrows="true" :dots="false" v-bind="settings"  v-if="featured_post.length" class="home_slider_new common_mobile_home_page_new job_detail_slider all_job_slider_detail">
                <div
                    v-if="featured_post.length"
                    v-for="(featured, h) in featured_post"
                    :key="h"
                    class=""
                >
                    <div class="whole_blog_home_two">
                        <div class="image_with_badge_section_home_two">
                            <div class="blog_image_two">
                                <img :src="(featured.image != null ? featured.image: webUrl+'assets/images/blog cover.webp')" :alt="`${featured.title} blog featured image`" loading="lazy">
                                <div class="image_overlay_home_two"></div>
                                <span class="blog_badge_home_two">{{featured.tag}}</span>
                            </div>
                        </div>
                        <div class="blog_box_home_two">
                            <span class="date_span_home_two">{{ featured.date | momentDate }}</span>
                            <h4 class="blog_heading_p_home_two">{{ featured.title }}</h4>
                        </div>
                        <b-link @click="blogDetail($event,featured.id,featured.title,featured.seo_permalink)" class="anchor_blog_home_two">
                            {{ $t('common.read_more') }} <span class="arrow_blog_read_more material-icons-outlined">arrow_forward_outlined</span>
                        </b-link>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>

    </div>
</template>

<script>
  // VueSlickCarousel is lazy-registered (in components below) so it's not a static dep of the
  // homepage chunk — keeps its ~327KB out of the always-loaded vendor bundle (P1d). The
  // carousel hydrates just after first paint. Theme CSS kept eager (small; arrows are also
  // overridden in style.css).
  import { POST_API } from '../../store/actions.type';
  import { getMetaInfo } from '@/seo.config';
  import Multiselect from 'vue-multiselect';
  import moment from 'moment';
  import { currentProfile } from "../../utils/countryGate";
  import CommonLocalBusinessSchemaComponent from "./CommonSchemaComponent/CommonLocalBusinessSchemaComponent.vue";
  import CommonSearchActionSchemaComponent from "./CommonSchemaComponent/CommonSearchActionSchemaComponent.vue";
  import QuickSearchLinks from './QuickSearchLinks.vue';

export default {
    metaInfo() { return getMetaInfo('/'); },
  data() {
    return {
        blogsettings:'',
        categories: [],
        sliderValue: 50,
        currentPage: 1,
        dailyjob_datas:[],
	    dailyjob_datas_count:'',
		job_categories:[],
        category_ftdp_job_type:'daily_paid',
        category_id_V1:'',
        categoriesV1: [],
		job_title_V1:'',
        
        jobSearchData:[],
        jobSearchArr: [],

        homepage_statistics: {},
        featured_post: [],
        error_message: '',
        webUrl: process.env.VUE_APP_URL,
        settings: {
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "speed": 800,
            "infinite": false,
		},
        blogSettings: {
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "speed": 800,
            "infinite": false,
		}
    };
  },
  filters: {
    stats_format: function(value) {
        if (!value) return '0'
        value = value.toString()
        if(value >= 1000 && value < 1000000){
            return value < 10000
                ? (value/1000).toFixed(1) + 'K ++'
                : Math.round(value/1000) + 'K ++';
        }
        else if(value >= 1000000){
            return (value/1000000).toFixed(1) + 'M ++';
        }
        else{
            return value;
        }
    },
    capitalize: function(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    },
    momentDate: function(date) {
        return moment(date).format("DD MMM YYYY")
    },
    momentTime: function(date) {
        return moment(date, "HH:mm:ss").format("hh:mm A")
    },
    momentFromNow: function (date) {
       return moment
        .tz(date, "YYYY-MM-DD HH:mm:ss", currentProfile().timezone)
        .local()
        .fromNow()
        // return moment(date).fromNow();;
    }
    
  },
  methods: {
    getHomepageData() {
      return this.$store
        .dispatch(POST_API, {
          data: {},
          api: "/api/homepage-data",

        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            return {};
          } else {
            this.homepage_statistics = this.$store.getters.getResults.data;
          }
        });
    },
    getBlogData() {
      return this.$store
        .dispatch(POST_API, {
          data: {},
          api: "/api/home-blog-data",

        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;
            return [];
          } else {
            this.featured_post = this.$store.getters.getResults.featured_post.slice(0,3);
          }
        });
    },
    blogDetail(event,id,title,seo_permalink){
        this.$store.dispatch(POST_API, {
        data:{
            id: id,
        },
        api:'/api/blog-detail-view-count'
        })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                return [];
            }
            else {
                this.blogDetail2(event,id,title,seo_permalink);
            }
        });
    },
    blogDetail2(event,id,title,seo_permalink){
        if (event) {
            event.stopPropagation()
        }
        if(seo_permalink == null){
            var titleNew = title.replace(/ /g, "-");
        }else{
            var titleNew = seo_permalink;
        }
        this.$router.push('/blog/'+ titleNew);
        // this.$router.push('/blog/detail/'+btoa(id)+ '/' +titleNew);

    },
    
    getAllJobOnSearchDPFT(event,category_id_V1,job_title_V1){
        const categoryAlias = category_id_V1 && category_id_V1.alias
            ? category_id_V1.alias
            : "";
        if(this.category_ftdp_job_type =='full_time'){
            this.getAllJobOnSearch(event,'all-role-jobs',categoryAlias,job_title_V1,'all-location-jobs');
        }else{
            this.getAllJobOnSearchDP(event,categoryAlias,job_title_V1);
        }
    },
    getAllJobOnSearch(event,role_type_id,category_id,job_title,location_id){
        if (event) {
            event.stopPropagation()
        }
        // console.log(role_type_id,category_id,job_title,location_id,location_id)
        role_type_id = role_type_id ? role_type_id: 'all-role-jobs';
        category_id = category_id ? category_id: 'all-categories-jobs';
        var company_id = 'all-companies-jobs';

        job_title = job_title ? job_title.split(' ').join('-'): 'all-title-jobs';
        location_id = location_id ? location_id: 'all-location-jobs';
        var allSearchData = {
            category_id: category_id,
            company_id: company_id,
            keyword:job_title.split(' ').join('-'),
        };

        localStorage.setItem('allSearchData', JSON.stringify(allSearchData))
        window.location.replace('/singapore-full-time-jobs/'+role_type_id+'/'+category_id+'/'+company_id+'/'+location_id+'/'+job_title);
    },
    getAllJobOnSearchDP(event,category_id_V1,job_title_V1){
        if (event) {
        event.stopPropagation()
        }
        // console.log(category_id_V1,job_title_V1)
        category_id_V1 = category_id_V1 ? category_id_V1: 'all-categories-jobs';
        var company_id_V1 = 'all-companies-jobs';
        job_title_V1 = job_title_V1 ? job_title_V1.split(' ').join('-'): '';
        var allSearchDataV1 = {
            category_id_V1: category_id_V1,
            company_id_V1: company_id_V1,
            keyword_V1:job_title_V1,
        };

        localStorage.setItem('allSearchDataV1', JSON.stringify(allSearchDataV1))
        // window.location.replace('/singapore-part-time-jobs/'+category_id_V1+'/'+company_id_V1+'/'+job_title_V1);
        this.$router.push('/singapore-part-time-jobs/'+category_id_V1+'/'+company_id_V1+'/'+job_title_V1); 
    },

    onChangeJobType(){
        this.category_id_V1 = '';
        this.getDropdownData();
    },
    getDropdownData(){
        var api = this.category_ftdp_job_type =='full_time' ? '/api/webCategory' : '/api/dropdown-list-category-v1'
        return this.$store.dispatch(POST_API, {
            data:{
                table:'service_categories',
                category_id_string:""
            },
            api:api
        })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;

                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: this.error_message,
                    showConfirmButton: false,
                    timer: 1500
                });

            } else {
                this.categoriesV1 = this.$store.getters.getResults.data;
            }
        });
    },
    getDPFTHomePageJobs() {
        window.scrollTo(0,0);
        return this.$store.dispatch(POST_API, {
            data:{
        },
        api: '/api/dp-ft-homepage-jobs'
        })
        .then(() => {
            if (this.$store.getters.containsErrors) {
                this.error_message = this.$store.getters.getErrors;
                this.showAlert();
                return [];
            } else {
                this.dailyjob_datas = this.$store.getters.getResults.dailyjob_datas;
                this.dailyjob_datas_count = this.dailyjob_datas.length;
                this.job_categories = this.$store.getters.getResults.job_categories;

            }
        });
    },
    
  },
  components: { VueSlickCarousel: () => import(/* webpackChunkName: "chunk-slick" */ 'vue-slick-carousel'), Multiselect, CommonLocalBusinessSchemaComponent, CommonSearchActionSchemaComponent, QuickSearchLinks },
  mounted() {
    Promise.all([
      this.categoriesV1.length       ? Promise.resolve() : this.getDropdownData(),
      this.dailyjob_datas.length     ? Promise.resolve() : this.getDPFTHomePageJobs(),
      this.homepage_statistics.job_count ? Promise.resolve() : this.getHomepageData(),
      this.featured_post.length      ? Promise.resolve() : this.getBlogData(),
    ]).finally(() => {
      document.dispatchEvent(new Event('x-app-rendered'));
    });
  },
};
</script>
